// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__34zal","legacyBtn":"MutateMid_legacyBtn__12XSP"};